/**
 * Uses open PO listing fields when poById is sparse:
 * – orderAmount when totalOrder missing
 * – currencyCode when header currency missing (BAQ parity across lookups)
 *
 * openRawPOs: GET_OPEN_POs rows for company + PO (project / manual lookups).
 */
export function attachOrderAmountFromOpenList(po, opts = {}) {
  if (!po || po.notFound) return po;
  const out = {...po};

  let matchedRow = null;
  const {openRawPOs, companyID, PONum} = opts;
  if (
    Array.isArray(openRawPOs) &&
    openRawPOs.length &&
    companyID != null &&
    PONum != null &&
    PONum !== ''
  ) {
    const pon = parseInt(PONum, 10);
    if (Number.isFinite(pon)) {
      const cid = String(companyID);
      matchedRow = openRawPOs.find(
        r =>
          r &&
          String(r.companyID) === cid &&
          parseInt(r.PONum, 10) === pon
      );
    }
  }

  if (out.totalOrder == null) {
    let amt = opts.preselectedOrderAmount;
    if (amt == null && matchedRow?.orderAmount != null)
      amt = matchedRow.orderAmount;
    if (amt != null) out.orderAmountFromOpenList = amt;
  }

  const curEmpty =
    out.currencyCode == null || String(out.currencyCode).trim() === '';
  if (curEmpty) {
    let cur =
      opts.preselectedCurrencyCode != null &&
      String(opts.preselectedCurrencyCode).trim() !== ''
        ? String(opts.preselectedCurrencyCode).trim().toUpperCase()
        : null;
    if (
      !cur &&
      matchedRow?.currencyCode != null &&
      String(matchedRow.currencyCode).trim() !== ''
    ) {
      cur = String(matchedRow.currencyCode).trim().toUpperCase();
    }
    if (cur) out.currencyCode = cur;
  }

  return out;
}
